/* Set your chart color scale here */

import { scaleOrdinal } from "d3-scale";

// FILL COLORS
const lightGray = "#E5E2E0";
const lighterGray = "rgba(229, 226, 224, 0.58)"
const orange = "#ffc266"
const lightOrange = "#ffe0b3"

const orange2 = "#ffad33"
const orange2light = "#ffcc80"

const orange3 = "#ff8c00"
const orange3light = "#f7aa4a"

const spotlightBlue = "rgba(0, 158, 219, 1)"
const spotlightLightBlue = "#99d9f1"

// WAPO
const wapoGray = "#4B4238"
const wapoBlue = "#79CDD8"
const wapoLightBlue = "#B4E1E6"

// FONT COLORS
const fontGray = "#4a4a4a"
const fontLightGray = "rgb(167, 167, 167)"
const offWhite = "#FCFCFC"
const offWhiteDarker = "#FBF6F7"

export const dominantColor = wapoBlue

export const domain = ["prohibited", "conditional", "no explicit ban"]

export const colorFillScale = scaleOrdinal()
  .domain(domain)
  .range([dominantColor, wapoLightBlue, lightGray])
  .unknown(lightGray);

export const colorTextScale = scaleOrdinal()
  .domain(domain)
  .range([wapoGray])
  .unknown(wapoGray)
